// src/CarouselComponent.js
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
// Import necessary styles
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import './CarouselComponent.css'; // Optional: For additional custom styling

function Testimonial() {
  const options = {
    items: 2, // Default items displayed
    nav: true, // Show navigation arrows
    rewind: true, // Rewind to start when reaching the end
    autoplay: true, // Automatically play the carousel
    loop: true, // Infinite loop
    dots: false, // Hide navigation dots
    responsive: {
      0: {
        items: 1, // Show 1 item on extra-small screens
      },
      600: {
        items: 1.5, // Show 1.5 items on small screens
      },
      768: {
        items: 2, // Show 2 items on tablets
      },
      1024: {
        items: 2.5, // Show 2.5 items on larger screens
      },
    },
  };

  return (
    <>
      <section className="testimonial-section style-two">
        <div className="auto-container">
          <div className="sec-title centred">
            <div className="title-two">
              <p>
                <span>{"{"}</span>&nbsp;Testimonials&nbsp;<span>{"}"}</span>
              </p>
            </div>
            <h3>
              Happy Customers Speak
            </h3>
          </div>

          <OwlCarousel className="owl-theme" {...options}>
            <div className="testimonial-content">
              <div className="inner-box">
                <div className="top-inner">
                  <div
                    className="pattern-layer"
                    style={{
                      backgroundImage: "url(assets/images/icons/pattern-20.png)",
                    }}
                  />
                  <div className="text">
                    <p>
                      "We rented a JCB machine from FixRental for a major excavation project.
                      The machine was in excellent condition and performed flawlessly. The team at
                      FixRental ensured timely delivery and excellent customer service. Highly recommend!""
                    </p>
                  </div>
                  <ul className="rating clearfix">
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                  </ul>
                </div>
                <div className="author-info">
                  <figure className="image-box">
                    <img
                      src="assets/images/resource/testimonial-1.png"
                      alt=""
                    />
                  </figure>
                  <h3>Rajesh Kumar</h3>
                  <span className="designation">Owner of "Kumar Construction Pvt. Ltd."</span>
                </div>
              </div>
            </div>
            <div className="testimonial-content">
              <div className="inner-box">
                <div className="top-inner">
                  <div
                    className="pattern-layer"
                    style={{
                      backgroundImage: "url(assets/images/icons/pattern-20.png)",
                    }}
                  />
                  <div className="text">
                    <p>
                      "We rely on FixRental for all our heavy machinery needs. Their
                      fleet of equipment is top-notch, and their customer support is
                      always there to assist. Renting equipment from them made our construction
                      site work smooth and efficient."
                    </p>
                  </div>
                  <ul className="rating clearfix">
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                  </ul>
                </div>
                <div className="author-info">
                  <figure className="image-box">
                    <img
                      src="assets/images/resource/testimonial-2.png"
                      alt=""
                    />
                  </figure>
                  <h3>Aarti Sharma</h3>
                  <span className="designation">Project Manager at "Sharma Infra Ltd."</span>
                </div>
              </div>
            </div>
            <div className="testimonial-content">
              <div className="inner-box">
                <div className="top-inner">
                  <div
                    className="pattern-layer"
                    style={{
                      backgroundImage: "url(assets/images/icons/pattern-20.png)",
                    }}
                  />
                  <div className="text">
                    <p>
                      "We recently rented equipment from FixRental for our ongoing infrastructure
                      project. We experienced no downtime, and the team at FixRental was very responsive to our needs.
                      Highly recommended for any construction project!"
                    </p>
                  </div>
                  <ul className="rating clearfix">
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                    <li>
                      <i className="fas fa-star" />
                    </li>
                  </ul>
                </div>
                <div className="author-info">
                  <figure className="image-box">
                    <img
                      src="assets/images/resource/testimonial-2.png"
                      alt=""
                    />
                  </figure>
                  <h3>Ravi Kumar</h3>
                  <span className="designation">Project Manager at "Sharma Infra Ltd."</span>
                </div>
              </div>
            </div>

          </OwlCarousel>
        </div>
      </section>
    </>
  );
}

export default Testimonial;
